const { ENTITY_TYPES, ATTRIBUTE_TYPES, ORG_TYPES } = require('../constants');

const getEntityName = ({ entity, entityType, attributes = {}, format } = {}, options) => {
  const { withDetails = true, withShortName = false, ignorePrimary = false } = options || {};
  const hasEntityAttributes = attributes[ATTRIBUTE_TYPES.ENTITY]?.length > 0;

  switch (entityType) {
    case ENTITY_TYPES.PROFILE: {
      const name = withShortName ? entity?.shortName : entity?.name;

      if (!withDetails || !hasEntityAttributes) {
        return name || '';
      }

      const professions = attributes[ATTRIBUTE_TYPES.ENTITY]
        .reduce((acc, item) => {
          if (item.entityType === ENTITY_TYPES.PROFESSION && (ignorePrimary || item.entity?.isPrimary)) {
            acc.push(item?.entity?.name);
          }

          return acc;
        }, [])
        .join(', ');

      if (professions) {
        return `${name || ''}, ${professions}`;
      }

      return name || '';
    }

    case ENTITY_TYPES.ORGANIZATION: {
      if (!withDetails || !hasEntityAttributes) {
        return entity?.name || '';
      }

      const city = attributes[ATTRIBUTE_TYPES.ENTITY].find(item => item.entityType === ENTITY_TYPES.CITY);
      const country = attributes[ATTRIBUTE_TYPES.ENTITY].find(item => item.entityType === ENTITY_TYPES.COUNTRY);
      let organizationTypeVenue = attributes[ATTRIBUTE_TYPES.ENTITY].find(
        item => item.entityType === ENTITY_TYPES.ORGANIZATION_TYPE && item.entity?.slug === ORG_TYPES.VENUE,
      );

      if (organizationTypeVenue && entity?.name.includes(organizationTypeVenue.name)) {
        organizationTypeVenue = '';
      }

      return [entity?.name, getEntityName(organizationTypeVenue), getEntityName(city), getEntityName(country)]
        .filter(Boolean)
        .join(', ');
    }

    case ENTITY_TYPES.WORK: {
      if (!withDetails || !hasEntityAttributes) {
        return entity?.name || '';
      }

      const creators = attributes[ATTRIBUTE_TYPES.ENTITY]
        .reduce((acc, item) => {
          if (item.entityType === ENTITY_TYPES.PROFILE) {
            acc.push(
              getEntityName({ entity: item.entity, entityType: ENTITY_TYPES.PROFILE }, { ...options, withShortName }),
            );
          }

          return acc;
        }, [])
        .join(', ');

      if (creators) {
        return `${entity?.name || ''}, ${creators}`;
      }

      return entity?.name || '';
    }

    case ENTITY_TYPES.WORK_TYPE: {
      if (!withDetails || !format) {
        return entity?.name || '';
      }

      const stagingType = getEntityName({ entityType: ENTITY_TYPES.STAGING_TYPE, entity: format });

      if (stagingType) {
        return `${entity?.name || ''} (${stagingType})`;
      }

      return entity?.name || '';
    }

    case ENTITY_TYPES.STAGING_TYPE:
    case ENTITY_TYPES.PROFESSION:
    default:
      return entity?.name || '';
  }
};

module.exports = getEntityName;
